module.exports = __webpack_public_path__ + "static/media/ic_epg_right.113c630b.svg";